import {AllFeedbackByRecipient, StateProps, ResponseData} from '../typedef';
import {ResetDataArgs, ReadDataArgs} from './typedef';
import {createSelector} from 'reselect';

export const feedbackData = (state: StateProps) => state.consolidatedFB;

const getFeedbackDetails = (data: ResponseData) => {
    const feedbackExists = data.responseData && data.responseData.some(item => item.feedbacks.length !== 0);
    return {
        feedbackExists,
        fetchedFeedback: data.responseData
    };
};

export const getFeedbackData = createSelector(
    feedbackData,
    getFeedbackDetails
);

export const resetData = (data: ResetDataArgs): AllFeedbackByRecipient[] => {
    const {feedbackStateData, response, rating, personId} = data;
    const newFeedback = feedbackStateData && personId ? feedbackStateData.responseData
        .find(feedback => feedback.profile.id === personId) : null;
    if (newFeedback) {
        if (newFeedback.feedbackConsolidated === null && response) {
            newFeedback.feedbackConsolidated = response;
        } else if (rating === null) {
            newFeedback.feedbackConsolidated = null;
        } else if (newFeedback.feedbackConsolidated && response) {
            newFeedback.feedbackConsolidated = response;
        }
    }
    return feedbackStateData.responseData && feedbackStateData.responseData
        .map(feedback => {
            if (newFeedback && newFeedback.profile.id === feedback.profile.id) {
                return newFeedback;
            } else {
                return feedback;
            }
        });
};

export const readData = (data: ReadDataArgs) => {
    const {feedbackStateData, feedbackId} = data;
    return feedbackStateData.responseData.map(item => {
        return {
            ...item,
            feedbacks: item.feedbacks.map(feedback => {
                if (feedback.feedbackId === feedbackId) {
                    return {
                        ...feedback,
                        isUpdated: false
                    };
                } else {
                    return feedback;
                }
            })
        };
    });
};
